import styled from 'styled-components';
import { layout } from '../../../../package.json';

export const ContainerSectionRequest = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 0 auto;
  height: inherit;
  padding: 0;

  @media (max-width: ${layout.tablet}) {
    flex-direction: column;
    > div + div {
      margin-top: 1rem;
    }
  }
`;

type ContainerSectionLeft = {
  enableMaxHeight: boolean;
}

export const ContainerSectionLeft = styled.div<ContainerSectionLeft>`
  width: 100%;
  min-height: 337px;
  display: flex;
  flex-direction: column;
  ${props => props.enableMaxHeight && `
   max-height: 580px;
  `}
  margin-right: 1rem;
  border: 1px solid #707070;
  padding: 10px;
  border-radius: 8px;

  @media (max-width: ${layout.tablet}) {
    margin-right: 0rem;
  }
`;

export const ContainerAddress = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: space-between;
  flex-direction: column;

  width: 100%;
  height: 100%;
`;

export const ContainerAddressList = styled.div`
  width: 100%;
`;

export const ContainerAddressRowHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;

  width: 100%;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 15px;

  > div + div {
    margin-left: 1rem;
  }
`;

export const AddressCreatedButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 160px;
  height: 30px;
`;

export const AddressAddress = styled.div``;

export const ContainerProducts = styled.div`
  width: 100%;
  flex: 1;
  overflow-y: auto;
`;

export const ContainerSectionRight = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;

  width: 100%;
  max-width: 450px;
  height: inherit;

  @media (max-width: ${layout.desktop}) {
    max-width: 350px;
  }
  @media (max-width: ${layout.tablet}) {
    justify-content: space-between;
    max-width: 100%;

    > div + div {
      margin-top: 1rem;
      margin-left: 0rem;
    }
  }
`;

export const ContainerDataRequest = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;

  width: 100%;

  border: 1px solid var(--primary);
  padding: 5px;
  border-radius: 8px;
`;

type ContainerStoreProps = {
  isMultiStore: boolean;
}

export const ContainerStore = styled.div<ContainerStoreProps>`
  width: 100%;
  display: flex;
  ${props => props.isMultiStore ? `
        align-items: center;
        justify-content: center;

          > div:last-of-type {
            width: 130px;
            height: 30px;
          }
    `: `
        align-items: start;
        justify-content: start;

        > div:last-of-type {
          height: 30px;
        }
    `}

  margin-bottom: 20px;
`

export const ContainerDataStore = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: left;
  flex-direction: column;

  span + span {
    font-size: 12px;
  }

  width: 100%;
  padding: 10px;
`;

export const ContainerDataRequestItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;

  width: 100%;
  padding: 10px;
`;

export const ContainerShippingItem = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;

  width: 100%;
  padding: 10px;
`;

export const ContaineItemShippingMode = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;

  width: 100%;

  > span {
    margin-top: 15px;
    font-weight: 500;
  }

  > div {
    width: 100%;
    margin-top: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  margin-bottom: 15px;
`;

export const ButtonShipping = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: center;
  width: 100%;

  > div {
    width: 100%;
    max-width: 280px;
  }
`;

export const ContainerDataDelivery = styled.div`
  width: 100%;
  margin-top: 15px;
  border: 1px solid var(--primary);
  padding: 5px;
  border-radius: 8px;
`;

export const ContainerDataDeliveryItem = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  width: 100%;
  padding: 10px;
`;
